const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

if (!username || !password) {
  throw new Error("Basic Auth env variables are missing");
}

export const BasicAuthUser = {
  username,
  password,
};